export * from './CbGenericTable'
